export enum TipoControleEstoque {
    'simplificado' = 'simplificado',
    'completo' = 'completo'
}